module.exports = __webpack_public_path__ + "static/media/ic_email_info.33667acd.svg";